/**
 * A map of the WebOs osVersion from the Chromium or AppleWebKit version in the userAgent's string
 */
export const webOsMapping: Record<number, number> = {
  25: 120,
  24: 108,
  23: 94,
  22: 87,
  6: 79,
  5: 68,
  4: 53,
} as const;
